import { Layout } from 'antd';
import React, { useState } from 'react';
import CustomHeader from './CustomHeader';
import CustomSidebar from './CustomSidebar';
import CustomFooter from './CustomFooter';
import { Outlet } from 'react-router-dom';
import './cardStyle.css';

const { Content } = Layout;

const CustomLayout = () => {
    const [sidebarVisible, setSidebarVisible] = useState(true);

    const handleButtonClick = () => {
        setSidebarVisible(!sidebarVisible);
    };


  return (
      <Layout className="custom-layout" style={{height:"100vh"}} >
          <CustomHeader onButtonClick={handleButtonClick} />

          <Layout>
              <CustomSidebar buttonClicked={sidebarVisible} />
              <Layout style={{height:"85vh" ,overflowY:"scroll",display:"flex",flexDirection:"column",flex:1}} className={`site-layout ${sidebarVisible ? 'content-with-sidebar' : 'content-full'}`}>
                  <Content
                      className="site-layout-background"
                      style={{
                          // marginLeft: '100px  ',
                          marginRight:'50px',
                          marginTop:'50px',
                          flex:1,
                           // Ensure the content takes full viewport height

                      }}
                  >

                      <Outlet />
                  </Content>




              </Layout>
          </Layout>
      </Layout>
  );
};
export default CustomLayout;
